<template>
  <a-drawer
    title="欢迎语配置"
    placement="right"
    :maskClosable="true"
    :closable="false"
    :visible="visible"
    @close="close"
    width="680"
  >
    <div class="material-component">
      <a-button
        v-if="!selectedKeys.id && !showMaterial"
        type="link"
        style="line-height: 400px; margin-left: 80px;"
        @click="getMaterial"
        >当前成员暂未添加欢迎语，点击添加></a-button
      >
      <a-row v-else :gutter="24" class="chatmass-texting-box">
        <a-col v-if="selectedKeys.id && !showMaterial" :span="8">
          <a-card :bordered="false" hoverable class="texting-card">
            <div>
              <div class="texting-card-text-box">
                <p class="texting-card-text-title">个人欢迎语</p>
                <p>{{ selectedKeys.textContent }}</p>
              </div>
              <img
                v-if="selectedKeys.imagePicUrl"
                class="imgpicurl"
                alt="example"
                :src="selectedKeys.imagePicUrl"
              />
              <div
                class="texting-card-img-box linkImg"
                v-else-if="selectedKeys.linkTitle"
              >
                <p>{{ selectedKeys.linkTitle }}</p>
                <div class="flex bottom-content">
                  <div class="flex_1">
                    {{ selectedKeys.linkDesc }}
                  </div>
                  <img
                    v-if="selectedKeys.linkPicurl"
                    class="linkpicurl"
                    alt="example"
                    :src="selectedKeys.linkPicurl"
                  />
                </div>
              </div>
            </div>
            <template slot="actions" class="ant-card-actions">
              <span @click="deleteWelcome" style="color: #f30508">删除</span>
              <span @click="showMaterial = true">更新</span>
            </template>
          </a-card>
        </a-col>
        <template v-else>
          <div v-if="material.length > 0">
            <a-col
              :span="8"
              v-for="item in material"
              :key="item.id"
              @click="getItem(item)"
            >
              <a-card
                :bordered="false"
                hoverable
                class="texting-card"
                :style="
                  selectedKeys.id === item.id
                    ? 'box-shadow: 0px 1px 6px #1790ff;'
                    : ''
                "
              >
                <div>
                  <div class="texting-card-text-box">
                    <p class="texting-card-text-title">
                      {{
                        item.chatType == 1
                          ? '个人欢迎语'
                          : item.chatType == 2
                          ? '渠道欢迎语'
                          : '群聊欢迎语'
                      }}
                    </p>

                    <p>{{ item.textContent }}</p>
                  </div>
                  <img
                    v-if="item.imagePicUrl"
                    class="imgpicurl"
                    alt="example"
                    :src="item.imagePicUrl"
                  />
                  <div
                    class="texting-card-img-box linkImg"
                    v-else-if="item.linkTitle"
                  >
                    <p>{{ item.linkTitle }}</p>
                    <div class="flex bottom-content">
                      <div class="flex_1">
                        {{ item.linkDesc }}
                      </div>
                      <img
                        v-if="item.linkPicurl"
                        class="linkpicurl"
                        alt="example"
                        :src="item.linkPicurl"
                      />
                    </div>
                  </div>
                </div>
              </a-card>
            </a-col>
          </div>
          <div v-else style="margin-left:20px;margin-top:20px;font-size:16px;">
            没有审核通过的欢迎语！
          </div>
        </template>
      </a-row>
      <div class="drawer-bootom-button">
        <a-popconfirm
          title="确定放弃编辑？"
          @confirm="close"
          okText="确定"
          cancelText="取消"
        >
          <a-button style="margin-right: 0.8rem">取消</a-button>
        </a-popconfirm>
        <a-button @click="handleSubmit" type="primary" :loading="confirmLoading"
          >{{ showMaterial ? '确认' : '提交' }}
        </a-button>
      </div>
    </div>
  </a-drawer>
</template>
<script>
import { getAction, postTag, postAction } from '../../../api/manage';
export default {
  data() {
    return {
      material: [],
      showMaterial: false,
      selectedKeys: {},
      visible: false,
      confirmLoading: false,
      url: {
        add:
          process.env.VUE_APP_CMS_WECHATUSERSBIZ +
          '/wechatwork/welcome/addEmployeeWelcome',
        welcomeDetail:
          process.env.VUE_APP_CMS_WECHATUSERSBIZ +
          '/wechatwork/welcome/getEmployeeWelcome',
        materialList:
          process.env.VUE_APP_CMS_GROUPCHAT +
          '/wechatwork/welcome/getMaterialFromDataBase',
        delete:
          process.env.VUE_APP_CMS_WECHATUSERSBIZ +
          '/wechatwork/welcome/deleteEmployeeWelcome'
      },
      form: {},
      type: ''
    };
  },

  methods: {
    add(record, type) {
      console.log(type, '=============', record);
      this.type = type;
      if (this.type == 'channel') {
        // 渠道
        this.selectedKeys = {
          ...record
        };
        this.selectedKeys.id = record.welcomeId;
        // console.log(this.selectedKeys.id,'------------');
        if (!record.welcomeId) {
          this.selectedKeys.id = record.relevanceId;
        }

        this.visible = true;
      } else {
        // 成员
        this.form.userid = record.userid;
        getAction(this.url.welcomeDetail, {
          id: record.userid
        }).then(res => {
          if (res.success) {
            let data = res.result || {};
            this.selectedKeys = data;
            this.form.relevanceId = data.relevanceId;
            this.form.id = data.id;
            if (!data.relevanceId) {
              this.selectedKeys.id = '';
            }

            this.visible = true;
          } else {
            this.$message.error(res.message);
          }
        });
      }

      getAction(this.url.materialList, {
        chatType: this.type == 'channel' ? '2' : '1' //个人欢迎语是1  渠道欢迎语是2
        // pageSize: 10,
        // page:1
      }).then(res => {
        if (res.success) {
          this.material = [];

          res.result.forEach(item => {
            if (item.status == 3) {
              if (item.imagePicUrl) {
                item.imagePicUrl =
                  process.env.VUE_APP_FILE_PATH + item.imagePicUrl;
              }
              this.material.push(item);
              console.warn(this.material);
            }
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    deleteWelcome(flag) {
      if (this.type == 'channel' || flag === 1) {
        this.selectedKeys = {};
      } else {
        postAction(this.url.delete, {
          employeeId: this.form.userid, // 员工Id
          id: this.form.relevanceId // 员工欢迎语关联主键
        }).then(res => {
          this.confirmLoading = false;
          if (res.success) {
            this.selectedKeys = {};
            this.$message.success('删除成功！');
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    getItem(item) {
      this.selectedKeys = item;
    },
    getMaterial() {
      this.showMaterial = true;
    },
    handleSubmit(flag) {
      if (this.showMaterial) {
        this.showMaterial = false;
        return false;
      }

      if (this.type == 'channel' || flag === 1) {
        // 渠道
        if (this.selectedKeys && this.selectedKeys.length > 0) {
          this.$message.success(flag === 1 ? '删除成功！' : '选择成功！');
        }

        this.$emit('ok');
        this.$emit('selectWelcome', this.selectedKeys, {
          welcomeId: this.selectedKeys.id // 欢迎语Id
        });
        this.close();
      } else {
        // 成员
        this.confirmLoading = true;
        postTag(this.url.add, {
          employeeId: this.form.userid, // 员工Id
          id: this.form.relevanceId, // 员工欢迎语关联主键
          welcomeId: this.selectedKeys.id // 欢迎语Id
          // relevanceId: this.form.relevanceId, // 关联Id 编辑时传
        }).then(res => {
          this.confirmLoading = false;
          if (res.success) {
            this.$message.success(res.message);
            this.$emit('ok');
            this.close();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    close() {
      this.showMaterial = false;
      this.visible = false;
      this.$emit('close');
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';

.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>

<style lang="less">
.material-component {
  .linkImg {
    background-color: #efefef;
  }

  .flex {
    display: flex;
  }

  .flex_1 {
    display: flex;
    flex: 1;
  }

  .imgpicurl {
    height: 120px;
    width: 100%;
  }

  .texting-card {
    padding: 0;
    height: 290px;
    // overflow: hidden;
    margin: 16px 0 16px 0;
    display: flex;
    flex-flow: column;
    align-items: center;
    border-radius: 4px;
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.1);
  }

  .link {
    height: 200px;
  }

  .texting-card-img-box {
    overflow: hidden;
    padding: 5px 10px;
  }

  .texting-card-img-box .linkpicurl {
    width: 40px;
    height: 40px;
    line-height: 48px;
  }

  .texting-card-img-box p {
    width: 100%;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    /* autoprefixer: ignore next */
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    word-break: break-all;
    word-wrap: break-word;
    color: #333;
    font-size: 15px;
    margin: 0 0 5px 0;
  }

  .texting-card-img-box img {
    width: 100%;
  }

  .bottom-content .flex_1 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    /* autoprefixer: ignore next */
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    word-break: break-all;
    word-wrap: break-word;
    width: 100%;
    line-height: 1.2;
  }

  .ant-card-body {
    padding: 0;
    flex: auto;
    width: 100%;
  }

  .chatmass-texting-box {
    padding-bottom: 25px;
  }

  .chatmass-texting-box .ant-card-body > div {
    display: flex;
    flex-flow: column;
    align-items: center;
    height: 100%;
  }

  .chatmass-texting-box .ant-card-body .texting-card-img-box {
    flex: none;
    width: 100%;
  }

  .texting-card-text-box {
    font-size: 18px;
    flex: auto;
    width: 100%;
    padding: 15px;
    padding-top: 30px;
  }

  .texting-card-text-box p {
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    word-break: break-all;
    word-wrap: break-word;
    font-size: 14px;
  }

  .texting-card-text-title {
    color: #d29114;
    border: 1px solid #9b9b9b;
    margin-bottom: 10px !important;
    width: 75px;
  }

  .texting-card .ant-card-actions {
    flex: none;
    width: 100%;
  }

  .chatmass-texting-add__btn .ant-card-body {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .chatmass-texting-add__desc {
    margin: 0;
  }
}
</style>
